import React from 'react'

export default function Professional() {

    const text= [
        "Direct Farmer Contact",
        " Fresh Products ",
        " After Sales Service",
        " Customer Satisfaction "
    ]


  return (
    <div className='flex flex-col '>
      
     <div className='flex'>
     <h3 className='text-3xl my-8 ml-8 text-center'> Professional Experience </h3>
      <p className='border-b-slate-950'></p>

     </div>
    <div>

<div className='flex flex-wrap py-4 w-full justify-around items-center'>
    
   {
    text.map((text1)=>(

       <div className='flex md:px-4 py-4 mt-4 px-24 flex-row justify-center w-[250px] '>
        <div className='w-[200px] '>
        <p className='text-7xl opacity-30 '> 100%</p>
        <p className='text-xl opacity-50 '> {text1} </p>
       </div>
       </div>
    ))
   }

</div>




    </div>

    </div>
  )
}
